import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IoPersonOutline } from 'react-icons/io5';
import { useLanguage } from '../../i18n/LanguageContext';
import { getStats, getOnlineUsers } from '../../api/AdminAPI';
import { imageSrc } from '../../utils/avatar';

export default function AdminDashboard() {
  const { t } = useLanguage();
  const history = useHistory();
  const [stats, setStats] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    let cancelled = false;

    (async () => {
      setLoading(true);
      const [statsData, onlineData] = await Promise.all([getStats(token), getOnlineUsers(token)]);
      if (cancelled) return;
      if (statsData.status === 'forbidden') { history.replace('/home'); return; }
      if (statsData.status === 'success') setStats(statsData.data);
      if (onlineData.status === 'success') setOnlineUsers(onlineData.data);
      setLoading(false);
    })();

    return () => { cancelled = true; };
  }, [history]);

  return (
    <div className="PageContainer">
      <div className="PageHeader glass">
        <h4>{t('admin.dashboard.title')}</h4>
        <aside className="descGray">{t('admin.dashboard.subtitle')}</aside>
      </div>
      <div className="Page glass" style={{ overflowY: 'auto' }}>
        {loading ? (
          <p style={{ padding: 20 }}>{t('common.loading')}</p>
        ) : (
          <>
            <div className="AdminStatGrid">
              <div className="AdminStatCard">
                <span className="AdminStatValue">{stats?.totalUsers ?? '-'}</span>
                <span className="AdminStatLabel">{t('admin.dashboard.totalUsers')}</span>
              </div>
              <div className="AdminStatCard">
                <span className="AdminStatValue">{stats?.newToday ?? '-'}</span>
                <span className="AdminStatLabel">{t('admin.dashboard.newToday')}</span>
              </div>
              <div className="AdminStatCard">
                <span className="AdminStatValue">{stats?.newThisWeek ?? '-'}</span>
                <span className="AdminStatLabel">{t('admin.dashboard.newThisWeek')}</span>
              </div>
              <div className="AdminStatCard">
                <span className="AdminStatValue">{stats?.newThisMonth ?? '-'}</span>
                <span className="AdminStatLabel">{t('admin.dashboard.newThisMonth')}</span>
              </div>
              <div className="AdminStatCard">
                <span className="AdminStatValue">{stats?.onlineCount ?? '-'}</span>
                <span className="AdminStatLabel">{t('admin.dashboard.online')}</span>
              </div>
            </div>

            <div className="AdminSection">
              <h5 style={{ margin: 0 }}>{t('admin.dashboard.onlineUsersTitle')}</h5>
              {onlineUsers.length === 0 ? (
                <p className="descGray">{t('admin.dashboard.noOnlineUsers')}</p>
              ) : (
                <div className="AdminTableWrap">
                  <table className="AdminTable">
                    <thead>
                      <tr>
                        <th>{t('admin.users.columnUser')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {onlineUsers.map((u) => (
                        <tr key={u.id}>
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              {u.imageUrl ? (
                                <img src={imageSrc(u.imageUrl)} alt="" style={{ width: 24, height: 24, borderRadius: '50%' }} />
                              ) : (
                                <IoPersonOutline />
                              )}
                              <span>{u.username}</span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
